/* global femcare */

femcare.article.articleList = {
    init: function() {
        this.category = '';
        this.pageIndex = 1;

        if ($('.list-articles-list').length) {
            this.initLoadMoreButton();
        }

        if ($('.list-articles-filtering').length) {
            this.initFiltering();
            this.initFilteringAjaxRequest();
        }
    },

    /**
     * Init filtering ajax request event.
     */
    initFilteringAjaxRequest: function() {
        var that = this;

        $('.list-articles-list form').submit(function(e) {
            e.preventDefault();

            var $container = $(this)
                    .parent()
                    .find('.list-articles-container'),
                $loadMoreButton = $('.list-articles-list__load-more'),
                categoryString = '';

            $loadMoreButton.remove();
            $container.addClass('loading');

            if (that.category) {
                categoryString = '?category=' + encodeURIComponent(that.category);
            }

            $.ajax({
                type: 'GET',
                data: $(this).serialize(),
                url: $(this).attr('action') + categoryString,
                success: function(data) {
                    $container.empty();
                    var articles = $(data)
                        .find('.list-articles-container')
                        .children();
                    var loadMoreButton = $(data).find('.list-articles-list__load-more');

                    if (articles.length) {
                        $container.append(articles);
                        $container.after(loadMoreButton);
                    }

                    $container.removeClass('loading');
                    that.pageIndex = 1;
                }
            });
        });
    },

    /**
     * Init load more articles after clicking load-more button event.
     */
    initLoadMoreButton: function() {
        var that = this;

        $(document).on('click', '.list-articles-list__load-more', function(e) {
            e.preventDefault();

            var $container = $(this)
                    .parent()
                    .find('.list-articles-container'),
                $loadMoreButton = $('.list-articles-list__load-more'),
                $form = $('.list-articles-list form'),
                hits = $('.list-articles-list form input[name=hits]').val(),
                offset = that.pageIndex * hits,
                categoryString = '';

            $container.addClass('loading');
            $loadMoreButton.prop('disabled', true);

            if (that.category) {
                categoryString = '&category=' + encodeURIComponent(that.category);
            }

            $.ajax({
                type: 'GET',
                data: $form.serialize(),
                url: $form.attr('action') + '?offset=' + offset + categoryString,
                success: function(data) {
                    $loadMoreButton.remove();
                    var articles = $(data)
                        .find('.list-articles-container')
                        .children();
                    var loadMoreButton = $(data).find('.list-articles-list__load-more');

                    if (articles.length) {
                        $container.append(articles);
                        $container.after(loadMoreButton);
                    }

                    $container.removeClass('loading');
                    that.pageIndex++;
                }
            });
        });
    },

    /**
     * Init and handle list article filter events.
     */
    initFiltering: function() {
        var $filterContainer = $('.list-articles-filtering'),
            $filterButtons = $('.list-articles-filters li a'),
            that = this;

        $filterButtons.on('click', function() {
            var $this = $(this);

            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
                $filterButtons.removeClass('active');
                $this.addClass('active');
            }

            that.category = $this.data('category');

            if ($('.list-articles-filters li a.active').length < 1) {
                $filterButtons
                    .filter('.list-articles-filters__all-filter')
                    .addClass('active');
                that.category = '';
            }

            $filterContainer.removeClass('list-articles-filtering--open');
            $('.list-articles-list form').submit();
        });

        $('.list-articles-filtering__toggle').on('click', function() {
            $filterContainer.toggleClass('list-articles-filtering--open');
        });
    }
};
